import React from "react";

const LiabilityListItem = ({ listData }) => {
  //   const listData = {
  //     id: 1,
  //     title: "Credit card bill",
  //     description: "3 month",
  //     duration: "2 years",
  //     rest: "6 months",
  //   };
  return (
    <div
      key={listData.id}
      style={{
        paddingTop: "1rem",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
      }}
      className="poppins underline-border p-b-1"
    >
      <div className="left">
        <h4 className="weight-500">{listData.title}</h4>
        <p className="t-12 color-grayColor">{listData.description}</p>
      </div>
      <div className="right">
        <p className="t-12 color-deepGreen3">{listData.duration}</p>
        <p className="t-12 color-textGray">(rest: {listData.rest})</p>
      </div>
    </div>
  );
};

export default LiabilityListItem;
